import type { TemplateConfig } from './constants.extra'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/immutable/config.json
 */
const TEMPLATE_CONFIG = {
  EIP155: false,
  SUPPORTED_VERSIONS: ['1.3.0', '1.4.1'],
  SAFE_UTILS_SUPPORTED: false,
  IS_LICENSED: false,
  LOGO_DIMENSIONS: {
    HEADER: { H: '40px' },
    WELCOME: { W: '240px', H: '60px' },
  },
} as TemplateConfig
export default TEMPLATE_CONFIG
